import s from './Likes.module.css';
import { NavigationHeader } from 'components/NavigationHeader/NavigationHeader';

import { useLocation } from 'react-router-dom';
import { BackButton } from 'components/BackButton/BackButton';
import { MenuLabel } from 'components/MenuLabels/MenuLabel';
import { CatsCollectionFavourite } from 'components/CatsCollection/CatsCollectionFavourite';
import { fetchLikes, fetchImage } from 'services/API/API';
import { useEffect, useState } from 'react';

const Likes = () => {
  const location = useLocation();

  const [images, setImages] = useState([]);

  useEffect(() => {
    fetchLikes(10).then(data => {
      data.map(({ image_id, value }) => {
        if (!!value) {
          fetchImage(image_id).then(data => setImages(prev => [...prev, data]));
        }
        return image_id;
      });
    });
  }, []);

  return (
    <div className={s.main}>
      <NavigationHeader />
      <div className={s.gallery}>
        <div className={s.backbutton}>
          <BackButton path={location.state ? location.state.path : '/'} />
          <MenuLabel name={'Likes'} />
        </div>
        <div className={s.collection}>
          <CatsCollectionFavourite images={images} />
        </div>
      </div>
    </div>
  );
};

export { Likes };
